'use client';

import React, { useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface VideoModalProps {
  isOpen: boolean;
  videoUrl: string;
  onClose: () => void;
}

const VideoModal: React.FC<VideoModalProps> = ({ isOpen, videoUrl, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-primary/90 backdrop-blur-sm animate-fade-in">
      <div className="relative w-full max-w-4xl bg-card rounded-lg overflow-hidden shadow-natural-lg">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 p-2 bg-card/90 backdrop-blur-sm rounded-full hover:bg-muted transition-colors duration-200"
          aria-label="Close video"
        >
          <Icon name="XMarkIcon" size={24} className="text-text-primary" />
        </button>

        <div className="relative pt-[56.25%]">
          <iframe
            src={videoUrl}
            title="Case Study Video Testimonial"
            className="absolute inset-0 w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default VideoModal;